import { handleGuestIdVerificationAndIdentityDispatch } from './personalize-sdk';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { env } from 'features/common/config/envConfig';
import { Environment } from '@sitecore-ui/portal-singular';

export const PersonalizeTracking = () => {
  const location = useLocation();
  const initialPathnameRef = useRef(location.pathname);

  useEffect(() => {
    let isCancelled = false;
    let script: HTMLScriptElement | null = null;

    const initializeEngage = () => {
      const settingsProd = {
        pointOfSale: 'default',
        cookieDomain: '.sitecorecloud.io',
      };
      // Personalize settings
      const settings = {
        clientKey: '1cc5231e2655eea6c724058e362f8e2a',
        targetURL: 'https://api-engage-eu.sitecorecloud.io',
        pointOfSale: 'portal-staging.sitecore-staging.cloud',
        cookieDomain: '.sitecore-staging.cloud',
        web_flow_target: 'https://d35vb5cccm4xzp.cloudfront.net',
        javascriptLibraryVersion: '1.4.9',
        cookieExpiryDays: 365,
        forceServerCookieMode: false,
        includeUTMParameters: true,
        webPersonalization: true,
      };

      if (env.toLowerCase() === Environment.production) {
        settings.pointOfSale = settingsProd.pointOfSale;
        settings.cookieDomain = settingsProd.cookieDomain;
      }

      // Avoid injecting the script multiple times (e.g. remounts / HMR)
      const existingScript = document.getElementById(
        'sitecore-engage-sdk',
      ) as HTMLScriptElement | null;
      if (existingScript) {
        return;
      }

      // Load Engage SDK script
      script = document.createElement('script');
      script.id = 'sitecore-engage-sdk';
      script.type = 'text/javascript';
      script.src =
        'https://d1mj578wat5n4o.cloudfront.net/sitecore-engage-v.1.4.1.min.js';
      script.async = true;
      script.onload = () => {
        const init = async () => {
          try {
            const Engage = (window as any).Engage;
            if (!Engage?.init) {
              return;
            }

            const engageInstance = await Engage.init(settings);
            if (isCancelled) return;

            (window as any).engage = engageInstance;

            try {
              await handleGuestIdVerificationAndIdentityDispatch({
                page: initialPathnameRef.current,
              });
            } catch (e) {
              // Engage SDK uses fetch under the hood; network failures should not crash the portal.
              console.error('Personalize identity dispatch failed', e);
            }
          } catch (e) {
            console.error('Personalize Engage init failed', e);
          }
        };

        void init();
      };
      script.onerror = (e) => {
        console.error('Failed to load Personalize Engage script', e);
      };

      document.head.appendChild(script);
    };

    initializeEngage();

    return () => {
      isCancelled = true;
      if (script?.parentNode) {
        script.parentNode.removeChild(script);
      }
      script = null;
    };
  }, []);

  /**
   * Track page view
   */
  useEffect(() => {
    const event = {
      channel: 'WEB',
      language: 'EN',
      currency: 'EUR',
      page: location.pathname,
    };

    if ((window as any).engage) {
      try {
        (window as any).engage.pageView(event);
      } catch (e) {
        console.error('Personalize pageView failed', e);
      }
    }
  }, [location.pathname]);

  return null;
};
